import { pick } from 'lodash';
import * as Yup from 'yup';

import { ShopStatus } from 'enums';
import { Shop } from 'types';

const MERCHANT_SHOP_FIELDS = [
  'name',
  'webSiteUrl',
  'webSiteIp',
  'shopIpWhitelist',
  'configs',
  'collectCustomerReceipts',
  'displayName',
] as const;

export const getMerchantShopPayload = (
  shop: Partial<Shop>,
  isNew: boolean,
): Partial<Shop> => ({
  ...pick(
    shop,
    isNew
      ? [...MERCHANT_SHOP_FIELDS, 'assetCurrencyId', 'fiatCurrencyId']
      : MERCHANT_SHOP_FIELDS,
  ),
  ...(isNew && { status: ShopStatus.Inactive }),
});

export const createShopFeeValidation = ({
  initialValues,
  isNew,
  isAdminOrTechOperator,
  isZeroFeesForbidden,
  t,
}: {
  initialValues: Pick<Shop, 'status' | 'commission'>;
  isNew: boolean;
  isAdminOrTechOperator: boolean;
  isZeroFeesForbidden: boolean;
  t: (key: string) => string;
}) => {
  const isZeroFeeForbidden = ({
    status,
    commission,
  }: Pick<Shop, 'status' | 'commission'>) =>
    isZeroFeesForbidden &&
    !commission &&
    status === ShopStatus.Active &&
    (isNew ||
      initialValues.status !== ShopStatus.Active ||
      Number(commission || 0) !== Number(initialValues.commission));

  return {
    commission: Yup.number()
      .min(0, t('errors.percentage'))
      .max(100, t('errors.percentage'))
      .test(
        'zero-fee-forbidden',
        t('errors.zero_fee_forbidden'),
        (_, context) =>
          !isAdminOrTechOperator || !isZeroFeeForbidden(context.parent),
      ),
  };
};
